import { Seo } from "../components/Seo";
import { useState } from "react";
import { Link } from "react-router-dom";
import { Plane, Loader2, MailCheck } from "lucide-react";
import api, { formatApiErrorDetail } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [result, setResult] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email, base_url: window.location.origin });
      setResult(data);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-6">
      <Seo title="Reset your password" noindex />
      <div className="w-full max-w-sm">
        <div className="mb-8">
          <img src="/pnr-decode-wordmark.png" alt="PNR Decode" className="h-14 w-auto object-contain" />
        </div>
        <h1 className="font-heading text-2xl font-bold text-slate-900 mb-1">Reset password</h1>
        <p className="text-sm text-slate-500 mb-6">Enter your email and we'll send you a link to reset your password.</p>

        {!result ? (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="email" className="text-slate-700">Email</Label>
              <Input data-testid="forgot-email" id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1" placeholder="you@example.com" />
            </div>
            {error && <div data-testid="forgot-error" className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-2">{error}</div>}
            <Button data-testid="forgot-submit" type="submit" disabled={loading} className="w-full bg-blue-600 hover:bg-blue-700 text-white">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Submit"}
            </Button>
          </form>
        ) : (
          <div data-testid="forgot-result" className="rounded-lg border border-slate-200 bg-white p-4 space-y-2">
            <div className="flex items-center gap-2 text-slate-900 font-medium">
              <MailCheck className="h-4 w-4 text-blue-600" /> Check your email
            </div>
            <p className="text-sm text-slate-500">{result.message}</p>
            <p className="text-xs text-slate-400">The link is valid for 1 hour. Don't forget to check your spam folder.</p>
          </div>
        )}

        <div className="mt-4 text-sm">
          <Link to="/login" className="text-slate-600 hover:underline">Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
